<script>
    import Datepicker from 'vuejs-datepicker';
    import {it} from 'vuejs-datepicker/dist/locale';
    import {Form} from '../../../helpers/Form/Form'

	export default {
		props: {
			company: Number
		},
		components: {Datepicker},
		data() {
			return {
				locale: it,
				form: new Form({
					company_id: this.company
				}),
				courses: [],
				tempFilterValues: {
					courses: [],
					user: null,
					date: null,
					is_member: null,
					not_member: null
				},
				filters: {
					courses: [],
					date: null,
					user: null,
					is_member: false,
					not_member: false					
				}
			}
		},
		watch: {
			'filters': {
				handler(val) {
					this.$emit('update-filters', val)
				},
				deep: true
			},
			'tempFilterValues.user': {
				handler(val) {
					if (_.isEmpty(val)) {
						$(this.$refs.users).val('').trigger('change')
					}
				}
			}
		},
		mounted() {
			this.initUsersSelect2()
			this.onSearchCourses()

            $(document)
                .on('click', '.dropdown-filter', (e) => {
                  e.stopPropagation();
                })       			
		},
		methods: {
			toggleCheck(course) {
				if (this.tempFilterValues.courses.includes(course.id)) {
					let idx = _.findIndex(this.tempFilterValues.courses, i => i == course.id)
					if (idx >= 0) {
						this.tempFilterValues.courses.splice(idx, 1)
					}
				} else {
					this.tempFilterValues.courses.push(course.id)
				}
			},
			onApplyFilters() {
				let copy = _.cloneDeep(this.filters)
				this.$emit('update-filters', Object.assign(copy, this.tempFilterValues))

				$("#reservation-filters").modal('hide')
			},
			toggleFilter(filter) {
				this.filters[filter] = !this.filters[filter]
			},
			toggleDropdownFilter(filter) {
				$(this.$refs[`toggle${_.capitalize(filter)}`]).dropdown('toggle')
			},
			isAppliedFilter(filter) {
				if (_.isBoolean(this.filters[filter])) {
					return this.filters[filter]
				}
				return !_.isEmpty(this.filters[filter])
			},
			onApplyFilter(filter) {
				if (filter == 'date') {
					this.$set(this.filters, filter, moment(this.tempFilterValues[filter]).format('YYYY-MM-DD'))
				} else {
					this.$set(this.filters, filter, this.tempFilterValues[filter])
				}

				$(this.$refs[`toggle${_.capitalize(filter)}`]).dropdown('toggle')
			},
			onRemoveAll() {		
				this.filters = {
					courses: [],
					date: null,
					user: null,
					is_member: false,
					not_member: false					
				}
				this.tempFilterValues = {
					courses: [],
					user: null,
					date: null
				}

				$("#reservation-filters").modal('hide')
			},
            onSearchCourses() {
            	this.form
            	  	.get(route('company.courses'))
            	  	.then(response => {
						this.$set(this, 'courses', response.courses.filter(i => i.is_active))        	  	
            	  	})
            },
            initUsersSelect2() {
            	let vm = this
                $(this.$refs.users).select2({
                    placeholder: 'Seleziona utente',
                    ajax: {
                        url: route('reservations.users'),
                        data: function (params) {
                            return {
                                'q': params.term,
                                'company_id': vm.company,
                            }
                        },
                        processResults: function (data) {
                            var results = [];
                            Object.keys(data.users)
                            	.forEach(function (i) {
	                                results.push({
	                                    'id': data.users[i],
	                                    'text': data.users[i],
	                                })
	                            });
                            // Transforms the top-level key of the response object from 'items' to 'results'
                            return {
                                results: results
                            };
                        }
                    }
                }).on('change', function (event) {
                    vm.$set(vm.tempFilterValues, 'user', $(this).val())
                })                      	
            },
            onRemoveFilter(filter) {
            	if (_.isArray(this.tempFilterValues[filter])) {
            		this.tempFilterValues[filter] = []
            		this.filters[filter] = []
            	} else {
            		this.tempFilterValues[filter] = null
            		this.filters[filter] = null
            	}

            	$(this.$refs[`toggle${_.capitalize(filter)}`]).dropdown('toggle')
            }
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/ReservationFilters.vue